/**
 * "Where are you in your story?" journey: one question at a time, then a summary with links.
 * Rebuilt from the original website's chapter modal as an inline, keyboard-friendly component.
 */
if (!customElements.get('itc-journey')) {
  customElements.define(
    'itc-journey',
    class ItcJourney extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-journey-step]'));
        this.result = this.querySelector('[data-journey-result]');
        this.progress = this.querySelector('[data-journey-progress]');
        this.summary = this.querySelector('[data-journey-summary]');
        this.backButton = this.querySelector('[data-journey-back]');
        this.restartButton = this.querySelector('[data-journey-restart]');
        this.baseSummary = this.summary ? this.summary.textContent : '';
        this.answers = [];
        this.current = 0;

        this.steps.forEach((step, index) => {
          step.querySelectorAll('[data-journey-choice]').forEach((choice) => {
            choice.addEventListener('click', () => this.choose(index, choice.textContent.trim()));
          });
        });
        this.backButton?.addEventListener('click', () => this.go(this.current - 1));
        this.restartButton?.addEventListener('click', () => {
          this.answers = [];
          this.go(0);
        });
        if (this.steps.length) this.go(0);
      }

      choose(index, answer) {
        this.answers[index] = answer;
        this.go(index + 1);
      }

      go(index) {
        const total = this.steps.length;
        this.current = Math.max(0, Math.min(index, total));
        this.steps.forEach((step, i) => (step.hidden = i !== this.current));
        const finished = this.current >= total;
        this.result.hidden = !finished;
        this.backButton.hidden = this.current === 0 || finished;
        this.restartButton.hidden = !finished;

        if (finished) {
          this.progress.textContent = 'Your constellation';
          const chosen = this.answers.filter(Boolean);
          if (this.summary && chosen.length) {
            this.summary.textContent = `Your interests: ${chosen.join(' · ')}. ${this.baseSummary}`;
          }
          this.result.querySelector('h2')?.setAttribute('tabindex', '-1');
          this.result.querySelector('h2')?.focus();
          return;
        }

        const label = this.dataset.stepLabel || 'Chapter [current] of [total]';
        this.progress.textContent = label.replace('[current]', this.current + 1).replace('[total]', total);
        if (index !== 0 || this.answers.length) {
          this.steps[this.current].querySelector('[data-journey-choice]')?.focus();
        }
      }
    }
  );
}
